import React, {Fragment, useState, useMemo} from 'react';
import {useApcLogs} from '../../hooks/';
import {TorchHoodDailyTable, TorchHoodMonthlyTable, TorchHoodLogModal} from './components/';
import moment from 'moment';
import {LinearProgress} from '@material-ui/core';

function roundNumber(n) {
  return Math.round(n * 10) / 10;
}

const TorchHoodView = () => {
  const [addLogModalOpen, setAddLogModalOpen] = useState(false);
  const [logsForOneMonth, setLogsForOneMonth] = useState(null);
  const [selectedLog, setSelectedLog] = useState(null);

  const apcLogs = useApcLogs();
  const dataForMonthlyTable = useMemo(() => {
    if (apcLogs?.TorchHood) {
      const mapOfData = {};
      apcLogs.TorchHood.forEach(doc => {
        const monthYear = moment(doc.Date).format('MM/YYYY');
        if (mapOfData[monthYear]) {
          mapOfData[monthYear].docs.push(doc);
          mapOfData[monthYear].TotalHours = roundNumber(mapOfData[monthYear].TotalHours + doc.Hours);
          mapOfData[monthYear].WeightTotal += doc.WeightTotal;
          mapOfData[monthYear].MeterStart = mapOfData[monthYear].MeterStart < doc.MeterStart ? mapOfData[monthYear].MeterStart : doc.MeterStart;
          mapOfData[monthYear].MeterEnd = mapOfData[monthYear].MeterEnd > doc.MeterEnd ? mapOfData[monthYear].MeterEnd : doc.MeterEnd;
        }
        else {
          mapOfData[monthYear] = {
            docs: [doc],
            TotalHours: doc.Hours,
            WeightTotal: doc.WeightTotal,
            MeterStart: doc.MeterStart,
            MeterEnd: doc.MeterEnd,
            Date: moment(monthYear, 'MM/YYYY').toDate(),
          };
        }
      });
      return Object.values(mapOfData);
    }
    else {
      return [];
    }
  }, [apcLogs]);

  const handleModalClose = () => {
    setSelectedLog(null);
    setAddLogModalOpen(false);
  };
  const openLogModal = (rowData=null) => {
    setAddLogModalOpen(true);
    if (rowData) setSelectedLog(rowData);
  };

  if (!apcLogs.TorchHood) return <LinearProgress />;

  return (
    <Fragment>
      {!logsForOneMonth ? <TorchHoodMonthlyTable data={dataForMonthlyTable}
        openModal={() => openLogModal()}
        handleViewRow={rowData => setLogsForOneMonth(rowData.docs)}
      /> : null}

      {logsForOneMonth ? <TorchHoodDailyTable data={logsForOneMonth}
        openModal={rowData => openLogModal(rowData)}
        handleBack={() => setLogsForOneMonth(null)}
      /> : null}
      {addLogModalOpen && <TorchHoodLogModal close={handleModalClose} selectedLog={selectedLog} />}
    </Fragment>
  );
};

export default TorchHoodView;
